<template>
  <div>
    <div id="content">
      <!-- Main Content -->
      <div
        class="main-content"
        v-if="loadedComponent"
        style="margin-top: -30px"
      >
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <img
                      class="profile-pic"
                      :src="user.photo"
                      alt="Chat Profile"
                    />
                    <div class="profile-info">
                      <div class="profile-name">{{ user.name }}</div>
                      <div class="profile-job">Colaborador</div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="profile-mail">
                      <span>E-mail:</span> {{ user.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="list-group list-group-flush">
                  <router-link
                    to="/profile/edit"
                    class="list-group-item list-group-item-action"
                    ><i class="far fa-user"></i>Editar Perfil</router-link
                  >
                  <!-- <a
                    href="notification.html"
                    class="list-group-item list-group-item-action"
                    ><i class="far fa-bell"></i>Notificações</a
                  >
                  <a
                    href="index.html"
                    class="list-group-item list-group-item-action"
                    ><i class="far fa-clipboard"></i>Atividades</a
                  >
                  <a
                    href="knowledge.html"
                    class="list-group-item list-group-item-action"
                    ><i class="far fa-folder-open"></i>Base de Conhecimento</a
                  >
                  <a
                    href="account.html"
                    class="list-group-item list-group-item-action"
                    ><i class="far fa-money-bill-alt"></i>Despesas</a
                  > -->
                  <button
                    @click="logout"
                    class="list-group-item list-group-item-action"
                  >
                    <i class="fas fa-sign-out-alt"></i>Sair
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      user: {},
      isLoading: true,
      fullPage: true,
      loadedComponent: false,
      actualDate: moment().format("LL"),
    };
  },
  computed: {},
  methods: {
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      self.$http
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          self.$router.push({ path: "/login" });
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
    bringData: function () {
      const self = this;
      const api = self.$store.state.api + "get-profile";

      self.loadedComponent = false;
      self.isLoading = true;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data;
          self.loadedComponent = true;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.isLoading = false;
        });
    },
  },
  components: { Loading },
  props: {},
  mounted: function () {
    this.bringData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Profile/Profile.vue